



























import { defineComponent, inject, onBeforeUnmount, ref, computed } from "@vue/composition-api";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import { format, parse, formatDate } from "@/lib/time";
import { FormValues } from "@/types";
import BaseChip from "@/components/BaseChip";
import BaseIcon from "@/components/BaseIcon";
import SchedulePostView from "../../../SchedulePostView";
import OptionItem from "../OptionItem";

export default defineComponent({
  name: "OptionSchedulePost",
  components: { OptionItem, BaseChip, BaseIcon, SchedulePostView },
  props: {
    postData: { type: Object as () => ContentSet, required: true },
  },
  setup(props) {
    const values = ref<FormValues>({});

    const setUpdateCb = inject<(cb: () => Promise<void>) => void>("setUpdateCb", async () => {});
    const removeCb = inject<(cb: () => Promise<void>) => void>("removeCb", async () => {});

    const showOption = computed<boolean>(() => !props.postData.publishTime);
    const date = computed<Date>(() =>
      parse(`${values.value.date} ${values.value.time}`, "yyyy-MM-dd HH:mm", new Date())
    );
    const scheduleTime = computed(() => {
      if (date.value.getTime() <= new Date().getTime()) return null;
      return formatDate(date.value, {
        month: "2-digit",
        day: "2-digit",
        year: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    });

    const getTitle = (isOpen: boolean) => {
      return scheduleTime.value && !isOpen ? $t("Scheduled for {0}", [scheduleTime.value]) : $t("Schedule post");
    };

    const onSetNow = (date = new Date()) => {
      values.value = {
        date: format(date, "yyyy-MM-dd"),
        time: format(date, "HH:mm"),
      };
    };

    onSetNow((props.postData.scheduleTime && new Date(props.postData.scheduleTime)) || undefined);

    const updateScheduleTime = async () => {
      if (!props.postData.scheduleTime && date.value.getTime() <= new Date().getTime()) return;
      await providers.ContentSetProvider.update({
        data: {
          id: props.postData.id,
          scheduleTime: date.value.toISOString(),
        },
      });
    };

    setUpdateCb(updateScheduleTime);
    onBeforeUnmount(() => {
      removeCb(updateScheduleTime);
    });

    const onReset = () => {
      onSetNow();
    };

    return {
      values,
      scheduleTime,
      getTitle,
      onReset,
      showOption,
    };
  },
});
